/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Close_LabelInputs */

const en_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close plain text import modal`)
};

const fr_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenetre d'importation de texte brut`)
};

const de_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modal zum Importieren von Klartext schließen`)
};

const it_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra modale di importazione del testo normale`)
};

const ru_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно импорта обычного текста`)
};

const es_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el modal de importación de texto sin formato`)
};

const zh_cn2_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭纯文本导入模态框`)
};

const ja_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレーンテキストインポートモーダルを閉じる`)
};

const hi_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साधारण पाठ आयात मॉडल बंद करें`)
};

const pt_pt2_plain_text_import_close_label = /** @type {(inputs: Plain_Text_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal de importação de texto simples`)
};

/**
* | output |
* | --- |
* | "Close plain text import modal" |
*
* @param {Plain_Text_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_close_label = /** @type {((inputs?: Plain_Text_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_close_label(inputs)
	if (locale === "de") return de_plain_text_import_close_label(inputs)
	if (locale === "it") return it_plain_text_import_close_label(inputs)
	if (locale === "ru") return ru_plain_text_import_close_label(inputs)
	if (locale === "es") return es_plain_text_import_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_close_label(inputs)
	if (locale === "ja") return ja_plain_text_import_close_label(inputs)
	if (locale === "hi") return hi_plain_text_import_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_close_label(inputs)
	return en_plain_text_import_close_label(inputs)
});